/*
* @Author: Irem Ercan
* @Date:   2018-01-08 18:44:05
* @Last Modified by:   Berkay Aydin
* @Last Modified time: 2018-04-19 13:38:58
*/
export default class feedbackIframeMessager {
  constructor(params) {
    this.formID = params.formID;
    this.ID = `JF_feedback_embed_${this.formID}_iframe`;
  }

  init() {
    // welcoming
  }

  sendPostMessage(data) {
    window.parent.postMessage(data, '*');
  }

  setOS(OS) {
    this.sendPostMessage({
      messageType: 'setOS',
      OS
    });
  }

  setDeviceType(deviceType) {
    this.sendPostMessage({
      messageType: 'setDeviceType',
      deviceType
    });
  }

  updateWindowHeight(data) {
    this.sendPostMessage(data);
  }
}
